import React from 'react'
import { Carousel, IconButton } from '@material-tailwind/react'

export default function CarouselApp({screenshots, modalOpen, setModalOpen}) {

    const isOpen = () => {
      if (!modalOpen) {
        setModalOpen(true)
      } else {

      }
    }

    return (
        <Carousel 
            transition={{ duration: 0.5 }} 
            className="max-w-80 rounded-2xl shadow-md bg-black overflow-y-hidden"
            prevArrow={({ handlePrev }) => (
                <IconButton
                  variant="text"
                  color="black"
                  size="xs"
                  onClick={handlePrev}
                  className="!absolute top-2/4 -translate-y-2/4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1}
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                    />
                  </svg>
                </IconButton>
              )}
              nextArrow={({ handleNext }) => (
                <IconButton
                  variant="text"
                  color="black"
                  size="xs"
                  onClick={handleNext}
                  className="!absolute top-2/4 right-0 -translate-y-2/4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1}
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                    />
                  </svg>
                </IconButton>
              )}
              // autoplay="false"
              loop="true"
              navigation={({ setActiveIndex, activeIndex, length }) => (
              <div className="absolute bottom-4 left-2/4 z-0 flex -translate-x-2/4 gap-2">
                  {new Array(length).fill("").map((_, i) => (
                    <span
                      key={i}
                      className={`block h-3 w-3 cursor-pointer rounded-full transition-colors content-[''] ${
                        activeIndex === i ? " bg-black" : " bg-black/20"
                      }`}
                      onClick={() => setActiveIndex(i)}
                    />
                  ))}
                </div>
              )}
        >
            {screenshots.map((item) => 
                <img
                src={item}
                alt="app screenshot"
                className="object-contain hover:cursor-pointer"
                onClick={isOpen}
            />
            )}
        </Carousel>
    )
}
